




















import { Component, Vue, Prop } from "vue-property-decorator";
import StatBlock from "../components/StatBlock.vue";
import { SubProjectModel } from "../models/subProject";
import money from "shared/filters/money";
import dateflip from "shared/filters/dateflip";

interface BlockData {
  label: string;
  value: string;
  tooltip: string;
  defaultValue?: string;
  titleFontSize?: string;
}

@Component({
  components: { StatBlock },
})
export default class StatBlocksSubProject extends Vue {
  @Prop({ required: true, type: Object }) private value!: SubProjectModel;

  get blockData(): BlockData[] {
    const t = (key: string): string =>
      this.$t("houseprojects.statsBlocks.subProject." + key).toString();
    return [
      {
        label: t("leaseSum.label"),
        value: money(this.value.lease_sum),
        tooltip: t("leaseSum.tooltip"),
      },
      {
        label: t("rentalIndexation.label"),
        value:
          this.value.rental_indexation_date == ""
            ? "Onbekend"
            : dateflip(this.value.rental_indexation_date),
        tooltip: t("rentalIndexation.tooltip"),
      },
      {
        label: t("deposit.label"),
        value: money(this.value.deposit),
        tooltip: t("deposit.tooltip"),
      },
      {
        label: t("status.label"),
        value: this.value.status,
        tooltip: t("status.tooltip"),
      },
    ];
  }
}
